import React, { Component } from 'react';
import styles from './Auth.module.css';
import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import { connect } from 'react-redux';
import { auth, authErrorMessageRemove } from '../../store/actions/auth';
import { validateEmail } from '../../helpers';

class Auth extends Component {
  state = {
    isFormValid: false,
    formControls: {
      email: {
        value: '',
        type: 'email',
        label: 'Email',
        errorMessage: 'Введите корректный email',
        valid: false,
        touched: false,
        validation: {
          required: true,
          email: true,
        }
      },
      password: {
        value: '',
        type: 'password',
        label: 'Пароль',
        errorMessage: 'Введите корректный пароль (не менее 6-ти цифр)',
        valid: false,
        touched: false,
        validation: {
          required: true,
          minLength: 6,
        }
      }
    }
  }

  loginHandler = () => {
    const { auth } = this.props
    const { formControls: { email, password } } = this.state

    auth(email.value, password.value, true)
  }

  registerHandler = () => {
    const { auth } = this.props
    const { formControls: { email, password } } = this.state

    auth(email.value, password.value, false)
  }

  submitHandler = event => event.preventDefault()

  validateControl(value, validation) {
    if (!validation) {
      return true
    }

    let isValid = true

    if (validation.required) {
      isValid = value.trim() && isValid
    }

    if (validation.email) {
      isValid = validateEmail(value) && isValid
    }

    if (validation.minLength) {
      isValid = value.length >= validation.minLength && isValid
    }
    return isValid
  }

  onChangeHandler = ({ target: { value } }, controlName) => {
    const { authErrorMessageRemove, authError, signUpError } = this.props

    const formControls = { ...this.state.formControls }
    const control = { ...formControls[controlName] }

    control.value = value
    control.touched = true
    control.valid = this.validateControl(control.value, control.validation)

    formControls[controlName] = control

    let isFormValid = true

    Object.keys(formControls).forEach(name => {
      isFormValid = formControls[name].valid && isFormValid
    })

    this.setState({
      formControls, isFormValid
    })

    if (authError || signUpError) {
      authErrorMessageRemove()
    }
  }

  renderInputs = () => {
    const { formControls } = this.state

    return Object.keys(formControls).map((controlName, index) => {
      const control = formControls[controlName]
      const { type, value, valid, touched, label, validation, errorMessage } = control

      return (
        <Input
          key={controlName + index}
          type={type}
          value={value}
          valid={valid}
          touched={touched}
          label={label}
          shouldValidate={!!validation}
          errorMessage={errorMessage}
          onChange={event => this.onChangeHandler(event, controlName)}
        />
      )
    })
  }

  render() {
    const { isFormValid } = this.state
    const { authError, signUpError } = this.props

    return (
      <div className={styles.auth}>
        <div>
          <h1>Авторизация</h1>

          <form onSubmit={this.submitHandler} className={styles.authForm}>

            {this.renderInputs()}
            {authError && <strong className={styles.error}>Вы ввели неверный пароль или логин. <br />
              Пожалуйста, проверьте введённые данные и повторите попытку.</strong>}

            {signUpError && <strong className={styles.error}>Введённый email уже зарегистрирован за пользователем. <br />
              Пожалуйста, проверьте введённые данные и повторите попытку.</strong>}
            <Button
              type="success"
              onClick={this.loginHandler}
              disabled={!isFormValid}
            >
              Войти
            </Button>

            <Button
              type="primary"
              onClick={this.registerHandler}
              disabled={!isFormValid}
            >
              Зарегистрироваться
            </Button>
          </form>
        </div>
      </div>
    )
  }
}

export default connect(({ auth: { authError, signUpError } }) => ({ authError, signUpError }), { auth, authErrorMessageRemove })(Auth)